import req from './request'

const DEFAULT_ENDPOINTS = {
    dashboard: '/dashboard',
    department: '/department',
    departmentRef:'/department/reference',
    park: '/park',
    authPark: '/park/auth',
    parkReff: '/park/reference',

    payment: '/dashboard/commissions',
    oferta: '/dashboard/offer',
    offerReference: '/dashboard/offer/reference',
    provider: '/provider',
    providerDetail: '/provider/detail',
    providerLog: '/provider/log',
    providerService: '/provider-service',
    providerServiceList: '/provider-service/providers',
    serviceByProvider: '/provider-service/service-by-provider',
    role: '/role',
    roleItems: '/role/items',
    sourceProvider:'/source-provider',
    suppliers: '/provider/suppliers',
    user: '/user',
    chat: '/platforms/chat',
    chatReference: '/platforms/chat/reference',
    chatSettings: '/platforms/chat/settings',
    applicationInstance: '/application-instance',
    applicationInstanceReference: '/application-instance/reference',
    applicationSetting: '/application-setting',
    applicationSettingRefference: '/application-setting/reference',
    applicationSettingWelcomeText: '/application-setting/welcome-text',
    sourceTarget:'/application-instance/source-target/',
    dashboardReference: '/dashboard/reference',

    applicationRevision:'/application-revision',
    security: '/dashboard/finance-security',
    userChangePass: '/user/change-password',
    spends: '/spends',
    rolesReference: '/dashboard/roles-reference',
    allert: '/company',
    ie: '/dashboard/ie',
    ieReference: '/dashboard/ie/reference',
    ieProcessingWorkRule: '/dashboard/ie/processing-work-rule',

    otherSettingReference: '/other/setting/reference',
    otherSetting: '/other/setting',
    contractors: '/dashboard/ie/contractors',
    companyContractors: '/company-contractors',
    sigex: '/dashboard/ie/sigex',
    sapar: '/dashboard/ie/sapar',
    referral: '/dashboard/referral',
    reference: '/dashboard/referral/reference',
    payda: '/dashboard/ie/payda',
    blockWithdraw: '/dashboard/ie/block-withdraw',
    blockWithdrawReference: '/dashboard/ie/block-withdraw/reference',

    offerList: '/dashboard/offer',
    getParks: '/dashboard/offer/get-parks',
    aboutUs: '/dashboard/about-us',

    aisettings: '/dashboard/ai/base',
    aisettingsPromo: '/dashboard/ai/promotion',
    aisettingsParks: '/dashboard/ai/parks',
    aiOffices: '/dashboard/ai/offices',
    aiLinks: '/dashboard/ai/links',
    aiLinksReference: '/dashboard/ai/links/reference',

    companiesSubscriptionsDetail: '/companies/subscriptions/detail',
    companiesSubscriptionsIndex: '/companies/subscriptions/index',
    companiesSubscriptionsActivate: '/companies/subscriptions/activate'
    

}
export default {
    parkReff(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.parkReff, param)
    },
    providerDetail(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.providerDetail, param)
    },
    authPark(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.authPark, param)
    },
    providerLog(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.providerLog, param)
    },
    departmentRef(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.departmentRef, param)
    },
    dashboardReference(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.dashboardReference, param)
    },
    sourceTarget(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.sourceTarget, param)
    },
    applicationSetting(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.applicationSetting, param)
    },
    applicationSettingRefference(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.applicationSettingRefference, param)
    },
    chatSettings(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.chatSettings, param)
    },
    chatReference(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.chatReference, param)
    },
    chat(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.chat, param)
    },
    dashboard(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.dashboard, param)
    },
    user(payload, param, method)  {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.user, param)
    },
    department(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.department, param)
    },
    park(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.park, param)
    },
    provider(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.provider, param)
    },
    providerService(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.providerService, param)
    },
    providerServiceList(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.providerServiceList, param)
    },
    serviceByProvider(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.serviceByProvider, param)
    },
    role(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.role, param)
    },
    roleItems(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.roleItems, param)
    },
    sourceProvider(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.sourceProvider, param)
    },
    payment(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.payment, param)
    },
    suppliers(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.suppliers, param)
    },
    applicationInstance(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.applicationInstance, param)
    },
    applicationInstanceReference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.applicationInstanceReference, param)
    },

    applicationRevision(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.applicationRevision, param)
    },

    oferta(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.oferta, param)
    },

    offerReference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.offerReference, param)
    },

    applicationSettingWelcomeText(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.applicationSettingWelcomeText, param)
    },
    security(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.security, param)
    },
    userChangePass(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.userChangePass, param)
    },

    spends(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.spends, param)
    },

    rolesReference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.rolesReference, param)
    },

    allert(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.allert, param)
    },

    ie(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.ie, param)
    },
    ieReference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.ieReference, param)
    }, 
    ieProcessingWorkRule(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.ieProcessingWorkRule, param)
    },
    otherSettingReference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.otherSettingReference, param)
    },
    otherSetting(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.otherSetting, param)
    },

    contractors(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.contractors, param)
    },
    companyContractors(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.companyContractors, param)
    },
    sigex(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.sigex, param)
    },
    sapar(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.sapar, param)
    },
    referral(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.referral, param)
    },
    reference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.reference, param)
    },
    payda(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.payda, param)
    },
    blockWithdraw(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.blockWithdraw, param)
    },
    blockWithdrawReference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.blockWithdrawReference, param)
    },
    offerList(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.offerList, param)
    },
    getParks(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.getParks, param)
    },
    aboutUs(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.aboutUs, param)
    },
    aisettings(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.aisettings, param)
    },
    aisettingsPromo(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.aisettingsPromo, param)
    },
    aisettingsParks(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.aisettingsParks, param)
    },
    aiOffices(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.aiOffices, param)
    },
    aiLinks(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.aiLinks, param)
    },
    aiLinksReference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.aiLinksReference, param)
    },
    companiesSubscriptions(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.companiesSubscriptionsIndex, param)
    },
    companiesSubscriptionsActivate(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.companiesSubscriptionsActivate, param)
    },
    companiesSubscriptionsGet(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.companiesSubscriptionsDetail, param)
    },

}